// Interactive appearance preview only; it does not form part of an order.
(() => {
 document.querySelectorAll('[data-theme-preview]').forEach(root => {
  let theme='universal';
  const select=root.querySelector('[data-reading]');
  const name=()=>theme==='universal'?'Modern':theme==='miata'?'Roadster':'Pixel · '+theme[0].toUpperCase()+theme.slice(1);
  function show(){
   const item=[...root.querySelectorAll('[data-theme-item]')].find(el=>el.dataset.themeItem===theme&&el.dataset.key===select.value);
   if(!item)return;
   const image=root.querySelector('[data-theme-image]');image.src=item.dataset.src;image.alt=name()+' · '+item.dataset.label+' preview';
   root.querySelector('[data-theme-caption]').textContent=name()+' · '+item.dataset.label;
  }
  function update(){
   const old=select.value;select.replaceChildren();
   root.querySelectorAll('[data-theme-item]').forEach(item=>{if(item.dataset.themeItem===theme){const option=document.createElement('option');option.value=item.dataset.key;option.textContent=item.dataset.label;select.append(option);}});
   if([...select.options].some(option=>option.value===old))select.value=old;
   root.querySelectorAll('[data-theme]').forEach(button=>{button.disabled=false;button.setAttribute('aria-pressed',String(button.dataset.theme===theme));});
   show();
  }
  root.querySelectorAll('[data-theme]').forEach(button=>button.addEventListener('click',()=>{theme=button.dataset.theme;update();}));
  select.addEventListener('change',show);update();
 });
})();
